const inlineStyles = {
    label: {
        fontSize: '12px',
        color: '#242b36',
        fontFamily: 'Roboto500',
    },
};
export default inlineStyles;
